<template>
  <v-container>
    <v-layout>
      <v-flex>
        <div class="headline primary--text">
          {{ $t('Tags Management') }}
        </div>
      </v-flex>
      <v-flex class="default-input">
        <v-text-field
          name="search"
          single-line
          :placeholder="$t('Search')"
          id="search"
          v-model="search"
          outline
          clearable
          prepend-inner-icon="search"
          hide-details
          @blur="onSearch"
          @keydown.enter="onSearch"
          @input="onSearch"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-1 mt-3"
      :pagination.sync="pagination"
      :loading="loading"
      :total-items="total"
    >
      <template v-slot:items="props">
        <tr>
          <td class="text-xs-center">{{ props.item.name }}</td>
          <td class="text-xs-right">
            <v-btn @click="onDelete(props.item.id)" fab small depressed>
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import api from '@/api'
export default {
  data() {
    return {
      search: '',
      headers: [
        {
          value: 'name',
          text: 'Name',
          align: 'center',
          sortable: false
        },
        {
          text: '',
          sortable: false
        }
      ],
      items: [],
      pagination: { sortBy: 'name', descending: true, rowsPerPage: 25 },
      loading: true,
      total: 0,
      updateSearchTimeout: null
    }
  },
  methods: {
    onSearch() {
      const vm = this
      if (vm.updateSearchTimeout) {
        clearTimeout(vm.updateSearchTimeout)
      }
      if (this.loading) return false
      vm.updateSearchTimeout = setTimeout(async () => {
        vm.loading = true
        try {
          const { result, total } = await vm.getUserTagList()
          vm.items = result
          vm.total = total
        } catch (error) {
          console.error(error)
        }
        vm.loading = false
        vm.updateSearchTimeout = null
      }, 3000)
    },
    async getUserTagList() {
      const { page, rowsPerPage } = this.pagination
      let offset = (page - 1) * rowsPerPage,
        limit = page * rowsPerPage
      var response = await api.getUserTagList({
        offset,
        limit,
        filter_name: this.search || undefined
      })
      if (response && response.result) {
        return { result: response.result, total: response.total_count || 0 }
      } else {
        return { result: [], total: 0 }
      }
    },
    async onDelete(id) {
      let result = await this.$swal.fire({
        title: this.$t('Do you want to delete this?'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        let index = this.items.findIndex((el) => el.id == id)
        if (index != -1) {
          let response = await api.deleteUserTagList({
            body: {
              id: id,
              tag: this.items[index].name
            }
          })
          if (response.success) {
            this.$swal.fire({
              type: 'success',
              title: this.$t('Success')
            })
            this.items.splice(index, 1)
          } else {
            this.$swal.fire({
              type: 'error',
              title: this.$t('Error')
            })
          }
        }
      }
    }
  },
  watch: {
    pagination: {
      async handler() {
        this.loading = true
        try {
          const { result, total } = await this.getUserTagList()
          this.items = result
          this.total = total
        } catch (error) {
          console.error(error)
        }
        this.loading = false
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/TagsManagement.vue